import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  isEmptyVal,
  isNotEmpty,
  displayField,
  getLabelFor,
} from "../../../utils/helpers";
import {
  mediaCatObjArr,
  mediaSourceObjArr,
  mediaTypeObjArr,
  songTypeObjArr,
} from "../../../core/config/AppConstants";

const SongInfoCell = ({
  dataKey,
  rowData,
  showData,
  ...props
}: {
  dataKey?: string;
  rowData: any;
  showData: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;

  const speaker = (
    <Popover title={t("SONG") + " " + t("INFO")}>
      {showData.includes("title") && (
        <p>
          <b>{t("TITLE")} : </b>
          {displayField(rowData.title)}
        </p>
      )}
      {showData.includes("singer1") && (
        <p>
          <b>{t("SINGER1")} : </b>
          {displayField(rowData.singer1_name)}
        </p>
      )}

      {showData.includes("singer2") && (
        <p>
          <b>{t("SINGER2")} : </b>
          {displayField(rowData.singer2_name)}
        </p>
      )}

      {showData.includes("singer3") && (
        <p>
          <b>{t("SINGER3")} : </b>
          {displayField(rowData.singer3_name)}
        </p>
      )}
      {showData.includes("singer4") && (
        <p>
          <b>{t("SINGER4")} : </b>
          {displayField(rowData.singer4_name)}
        </p>
      )}
      {showData.includes("album") && (
        <p>
          <b>{t("ALBUM")} : </b>
          {displayField(rowData.album)}
        </p>
      )}
      {showData.includes("actor1") && (
        <p>
          <b>{t("ACTOR1")} : </b>
          {displayField(rowData.actor1_name)}
        </p>
      )}
      {showData.includes("actor2") && (
        <p>
          <b>{t("ACTOR2")} : </b>
          {displayField(rowData.actor2_name)}
        </p>
      )}
      {showData.includes("actor3") && (
        <p>
          <b>{t("ACTOR3")} : </b>
          {displayField(rowData.actor3_name)}
        </p>
      )}
      {showData.includes("lyricist") && (
        <p>
          <b>{t("LYRICIST")} : </b>
          {displayField(rowData.lyricist)}
        </p>
      )}
      {showData.includes("composer") && (
        <p>
          <b>{t("COMPOSER")} : </b>
          {displayField(rowData.composer)}
        </p>
      )}
      {showData.includes("media_duration") && (
        <p>
          <b>{t("DURATION")} : </b>
          {displayField(rowData.media_duration)}
        </p>
      )}
      {showData.includes("label") && (
        <p>
          <b>{t("LABEL")} : </b>
          {displayField(rowData.label)}
        </p>
      )}
      {showData.includes("tempo") && (
        <p>
          <b>{t("TEMPO")} : </b>
          {displayField(rowData.tempo)}
        </p>
      )}
      {showData.includes("language") && (
        <p>
          <b>{t("LANGUAGE")} : </b>
          {displayField(rowData.language_title)}
        </p>
      )}
      {showData.includes("mood") && (
        <p>
          <b>{t("MOOD")} : </b>
          {displayField(rowData.moods)}
        </p>
      )}
      {showData.includes("genre") && (
        <p>
          <b>{t("GENRE")} : </b>
          {displayField(rowData.genre_title)}
        </p>
      )}
      {showData.includes("sub_genre") && (
        <p>
          <b>{t("SUB_GENRE")} : </b>
          {displayField(rowData.sub_genre_title)}
        </p>
      )}
      {showData.includes("license") && (
        <p>
          <b>{t("LICENSE")} : </b>
          {displayField(rowData.license_title)}
        </p>
      )}
      {showData.includes("song_type") && (
        <p>
          <b>
            {t("SONG")} {t("TYPE")} :{" "}
          </b>
          {getLabelFor(rowData.song_type, songTypeObjArr)}
        </p>
      )}
      {showData.includes("media_type") && (
        <p>
          <b>
            {t("MEDIA")} {t("TYPE")} :{" "}
          </b>
          {getLabelFor(rowData.media_type, mediaTypeObjArr)}
        </p>
      )}
      {showData.includes("sourced_from") && (
        <p>
          <b>
            {t("SOURCED")} {t("FROM")} :{" "}
          </b>
          {getLabelFor(rowData.sourced_from, mediaSourceObjArr)}
        </p>
      )}
      {showData.includes("media_category") && (
        <p>
          <b>
            {t("MEDIA")} {t("CATEGORY")} :{" "}
          </b>
          {getLabelFor(rowData.media_category, mediaCatObjArr)}
        </p>
      )}
      {showData.includes("era") && (
        <p>
          <b>{t("ERA")} : </b>
          {displayField(rowData.era)}
        </p>
      )}

      {showData.includes("festive_season") && (
        <p>
          <b>
            {t("FESTIVE")} {t("SEASON")} :{" "}
          </b>
          {displayField(rowData.festive_season)}
        </p>
      )}
      {showData.includes("release_year") && (
        <p>
          <b>
            {t("RELEASE")} {t("YEAR")} :{" "}
          </b>
          {displayField(rowData.release_year)}
        </p>
      )}
      {showData.includes("rating_chart") && (
        <p>
          <b>
            {t("RATING")} {t("CHART")} :{" "}
          </b>
          {displayField(rowData.rating_chart_title)}
        </p>
      )}
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{t("INFO")}</a>
      </Whisper>
    </Cell>
  );
};

export default SongInfoCell;
